import * as React from 'react';
import classnames from 'classnames';
import forwardRef from '@roo/create-react-ref/forwardRef';

var TabBar = function TabBar(_ref, ref) {
  var value = _ref.value,
      tabList = _ref.tabList,
      onTabClick = _ref.onTabClick,
      style = _ref.style,
      pointerStyle = _ref.pointerStyle,
      type = _ref.type;
  return /*#__PURE__*/React.createElement("div", {
    className: "roo-tabs-nav-wrap"
  }, /*#__PURE__*/React.createElement("ul", {
    className: "roo-tabs-nav",
    style: style,
    ref: ref
  }, tabList.map(function (item) {
    return /*#__PURE__*/React.createElement("li", {
      key: item.name,
      className: classnames('tab-item', {
        disabled: item.disabled,
        active: item.name === value
      }),
      onClick: function onClick() {
        return !item.disabled && onTabClick(item.name);
      }
    }, /*#__PURE__*/React.createElement("a", null, /*#__PURE__*/React.createElement("span", null, item.label)));
  }), type === 'line' && /*#__PURE__*/React.createElement("div", {
    style: pointerStyle,
    className: "roo-tabs-pointer"
  }), /*#__PURE__*/React.createElement("div", {
    className: "roo-tabs-border-line"
  })));
};

export default forwardRef(TabBar);